import { afterNextRender, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeModel } from '@core/models/domains/home-page-flex';
import { HomeUiService } from '../home-ui.service';
import { BehaviorSubject, map, Observable, take } from 'rxjs';
import { fadeAnimation } from '../home-page-wrapper.component';
import { SearchBoxService } from '@shared/services/serach-box.service';
@Component({
 selector: 'iho-ecolodge-wrapper',
 templateUrl: './ecolodge-wrapper.component.html',
 styleUrls: ['./ecolodge-wrapper.component.scss'],
 animations: [fadeAnimation],
})
export class EcolodgeWrapperComponent {
 router = inject(Router);
 homeUiService = inject(HomeUiService);
 route = inject(ActivatedRoute);
 searchBoxService = inject(SearchBoxService);
 resetSwiper: WritableSignal<boolean> = signal(true);
 ecolodgeDataSource = this.homeUiService.getAllSections('ecolodge').pipe(take(1))!;
 ecolodgeTypes = this.ecolodgeDataSource.pipe(map((data) => data['Sections'][0].Section));
 mostVisitedDestinations = this.ecolodgeDataSource.pipe(map((data) => data['Sections'][1].Section));
 rentingResidence = this.ecolodgeDataSource.pipe(
  map((data) => data['Sections'][2].Section.Data.Details[0].Infos)
 );
 bigBannerDataSource = this.ecolodgeDataSource.pipe(
  map((data) => {
   return {
    top: data['Sections'][3].Section.Data,
    bottom: data['Sections'][4].Section.Data,
   };
  })
 );
 squaretextDataSource = this.ecolodgeDataSource.pipe(map((data) => data['Sections'][5]));

 constructor() {
  afterNextRender(() => {
   this.resetSwiper.set(false);
   setTimeout(() => this.resetSwiper.set(true), 0);
  });
 }

 emitActiveTab(ev: string) {
  this.rentingResidence = this.homeUiService.getSectionById(
   ev.split('?')[1]
  ) as BehaviorSubject<any>;
 }
}
